import { Flex } from '@mantine/core';
import { Formik, Form as FormikForm, FormikValues } from 'formik';
import { ComponentPropsWithoutRef } from 'react';
import styles from './styles.module.css';

type FormProps<T extends FormikValues> = ComponentPropsWithoutRef<typeof Formik<T>>;

export function Form<T extends FormikValues>({ children, ...props }: FormProps<T>) {
	return (
		<Flex direction="column" justify="center" align="flex-start" className={styles.root}>
			<Formik<T> {...props}>
				{(renderProps) => (
					<Flex component={FormikForm} className={styles.form} gap="md">
						{typeof children === 'function' ? children(renderProps) : children}
					</Flex>
				)}
			</Formik>
		</Flex>
	);
}
